import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ConfigurationService } from '../../../../../Configuration/configuration.service';
@Injectable({
  providedIn: 'root'
})
export class DirectorremunerationService {
 // URL = environment.apiUrl +'/api/LandAndBuildings/';
  URl = this.ConfigService.getAPIBaseUrl() + 'api/Directors_remuneration/';
  constructor(public HttpClient: HttpClient, private ConfigService: ConfigurationService) { }


SaveDirectorremuneration(directors_Remunerations) {
    debugger;
  return this.HttpClient.post(this.URl + 'InsertDirectorsremuneration', directors_Remunerations)
  }
  GetAllDirectorremuneration(data) {
    debugger;
    return this.HttpClient.get(this.URl +"GetAll",data)
  }
  GetOneDirectorremuneration(APPeriodId) {
    debugger;
    return this.HttpClient.get(this.URl + "GetDirectorsremuneration?APPeriodId=" + APPeriodId)
  }
  GetOneDirectorremuneration_LY(APPeriodId) {
    debugger;
    return this.HttpClient.get(this.URl + "GetDirectorsremuneration_LY?APPeriodId=" + APPeriodId)
  }
  DeleteDirectorremuneration(id) {
    debugger;
    return this.HttpClient.post(this.URl +"GetOne",id)
  }

}
